import gql from 'graphql-tag'

export const createCompanyInvitationDelete = gql`
  mutation createCompanyInvitationDelete($invitationId: ID!) {
    createCompanyInvitationDelete(input: { invitationId: $invitationId }) {
      deletedInvitationId
    }
  }
`
